<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">

          <div class="col-12">
        
            <div class="card" v-if="$gate.isAdmin1()">
              <div class="card-header">
                <h3 class="card-title">Daftar Sumber Dana</h3>

                <!--<div class="card-tools">
                  
                  <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                      <i class="fa fa-plus-square"></i>
                      Tambah Sumber Dana
                  </button>
                </div>-->
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <!--th>ID</th-->
                      <th>Nama</th>
                      <!--<th>Action</th>-->
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="sumber_dana in sumber_danas.data" :key="sumber_dana.id">

                      <!--td>{{sumber_dana.id}}</td-->
                      <td class="text-capitalize">{{sumber_dana.nama}}</td>
                      <!--<td>

                        <a href="#" @click="editModal(sumber_dana)">
                            <i class="fa fa-edit blue"></i>
                        </a>
                      </td>-->
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <pagination :data="sumber_danas" @pagination-change-page="getResults"></pagination>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>


        <div v-if="!$gate.isAdmin1()">
            <not-found></not-found>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Tambah Sumber Dana</h5>
                    <h5 class="modal-title" v-show="editmode">Ubah Sumber Dana</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? updateSumberDana() : createSumberDana()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Nama Sumber Dana</label>
                            <input v-model="form.nama" type="text" name="nama"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('nama') }">
                            <has-error :form="form" field="nama"></has-error>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Simpan</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Simpan</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    export default {
        data () {
            return {
                editmode: false,
                sumber_danas : {},
                form: new Form({
                    id : '',
                    nama: '',
                })
            }
        },
        methods: {

            getResults(page = 1) {

                  this.$Progress.start();
                  
                  axios.get('/api/sumber_dana?page=' + page).then(({ data }) => (this.sumber_danas = data.data));

                  this.$Progress.finish();
            },
            updateSumberDana(){
                this.$Progress.start();
                this.form.put('/api/sumber_dana/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.loadSumberDanas();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },
            editModal(sumber_dana){
                this.editmode = true;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.fill(sumber_dana);
            },
            newModal(){
                this.editmode = false;
                this.form.reset();
                $('#addNew').modal('show');
            },

            loadSumberDanas(){
                if(this.$gate.isAdmin1()){
                    axios.get("/api/sumber_dana").then(({ data }) => (this.sumber_danas = data.data));
                }
            },
            
            createSumberDana(){

                this.form.post('/api/sumber_dana')
                .then((response)=>{
                    $('#addNew').modal('hide');

                    Toast.fire({
                            icon: 'success',
                            title: response.data.message
                    });

                    this.$Progress.finish();
                    this.loadSumberDanas();
                })
                .catch(()=>{
                    Toast.fire({
                        icon: 'error',
                        title: 'Some error occured! Please try again'
                    });
                })
            }

        },
        mounted() {
            console.log('Component mounted.')
        },
        created() {

            this.$Progress.start();
            this.loadSumberDanas();
            this.$Progress.finish();
        }
    }
</script>